import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ApprovalTypes } from '../../types';
import { getTranslatedApprovalTypeCapitalised } from '../../utils/translationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalUnifiedEventApprovedI18n = props => {
  const {
    approvalAction,
    event
  } = props;
  const assetType = getTranslatedApprovalTypeCapitalised(event.properties.hs_approval_type.value);
  switch (approvalAction) {
    case 'MOVE_STAGE':
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventApproved.moveStage",
        options: {
          assetType
        }
      });
    case 'PUBLISH':
    default:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventApproved.publish",
        options: {
          assetType
        }
      });
  }
};
export const ApprovalUnifiedEventConcludedI18n = props => {
  const {
    approvalAction,
    event
  } = props;
  const approvalType = event.properties.hs_approval_type.value;
  const assetType = getTranslatedApprovalTypeCapitalised(approvalType);
  switch (approvalAction) {
    case 'MOVE_STAGE':
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventConcluded.moveStage",
        options: {
          assetType
        }
      });
    case 'PUBLISH':
    default:
      if (approvalType === ApprovalTypes.QUOTE) {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.unifiedEvents.ApprovalUnifiedEventConcluded.quoteSubmitted",
          options: {
            assetType
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventConcluded.publish",
        options: {
          assetType
        }
      });
  }
};